import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "settingsFilled"
const SettingsFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5Q12.919 1.5 13.796 1.653L14.045 1.7 14.517 1.793 15.137 4.37C15.822 4.65 16.459 5.022 17.036 5.467L19.575 4.717 19.892 5.078C20.79 6.1 21.495 7.3 21.944 8.621L22.098 9.075 20.174 10.904C20.222 11.26 20.25 11.627 20.25 12Q20.248 12.56 20.174 13.096L22.099 14.925 21.945 15.379C21.496 16.699 20.79 17.898 19.893 18.92L19.576 19.28 17.036 18.531C16.458 18.976 15.821 19.348 15.137 19.63L14.517 22.206 14.045 22.3C13.384 22.43 12.7 22.5 12 22.5S10.615 22.43 9.953 22.3L9.482 22.206 8.86 19.63C8.176 19.347 7.54 18.976 6.963 18.53L4.423 19.281 4.107 18.921C3.209 17.898 2.503 16.699 2.054 15.378L1.901 14.924 3.825 13.095Q3.75 12.559 3.75 12 3.75 11.44 3.825 10.904L1.9 9.075 2.054 8.621C2.504 7.301 3.21 6.101 4.107 5.077L4.424 4.717 6.964 5.468C7.54 5.022 8.177 4.65 8.86 4.37L9.482 1.793 9.952 1.699C10.617 1.57 11.3 1.5 12 1.5M12 8.625C10.136 8.625 8.625 10.136 8.625 12S10.136 15.375 12 15.375 15.375 13.864 15.375 12 13.864 8.625 12 8.625"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SettingsFilledIcon
